import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Reusable Components
import CircularPhotoCard from "reusables/Cards/CircularPhotoCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

// Images
import kitchen from "assets/images/Services/Tenancy/kitchen1.jpg";
import bathroom from "assets/images/Services/Tenancy/bathroom1.jpg";
import livingBedroom1 from "assets/images/Services/Tenancy/living-bedroom1.jpg";
import hallwaysEntry from "assets/images/Services/Tenancy/hallways-entry1.jpg";
import additional1 from "assets/images/Services/Tenancy/additional1.jpg";

// Data for End of Tenancy Cleaning Services
const cleaningCategories = [
  {
    image: kitchen,
    name: "Kitchen",
    position: { color: "info", label: "" },
    description: [
      "Deep cleaning of all surfaces, countertops, and cupboards (inside and out)",
      "Degreasing and cleaning stovetops, ovens, and extractor fans",
      "Cleaning sinks, taps, and removing limescale",
      "Polishing exterior of appliances (e.g., fridge, dishwasher)",
      "Vacuuming and mopping floors",
    ],
  },
  {
    image: bathroom,
    name: "Bathroom",
    position: { color: "info", label: "" },
    description: [
      "Scrubbing and disinfecting toilets, sinks, showers, and bathtubs",
      "Polishing mirrors and fixtures",
      "Removing limescale and soap scum from tiles and glass surfaces",
      "Cleaning and sanitizing bathroom floors",
    ],
  },
  {
    image: livingBedroom1,
    name: "Living Areas and Bedrooms",
    position: { color: "info", label: "" },
    description: [
      "Dusting and wiping down all surfaces, furniture, and baseboards",
      "Cleaning interior windows, sills, and frames",
      "Vacuuming carpets and rugs or mopping hard floors",
      "Removing cobwebs from ceilings and corners",
    ],
  },
  {
    image: hallwaysEntry,
    name: "Hallways and Entry Areas",
    position: { color: "info", label: "" },
    description: [
      "Cleaning doors, handles, and light switches",
      "Dusting and wiping skirting boards and baseboards",
      "Vacuuming or mopping floors",
    ],
  },
  {
    image: additional1,
    name: "Additional Areas",
    position: { color: "info", label: "" },
    description: [
      "Cleaning utility rooms, storage spaces, and outdoor areas",
      "Thorough inspection to ensure all areas meet the highest cleaning standards",
    ],
  },
];

function EndOfTenancy_Section2() {
  return (
    <Container>
      <Grid container direction="column" sx={{ mx: "auto" }} width="100%">
        <Grid item>
          <SubTitleContents
            title="What’s Included in Our End of Tenancy Cleaning Services?"
            contents="Our end-of-tenancy cleaning services ensure your property is spotless and ready for the next tenant or inspection. Here’s what’s typically included:"
          />
        </Grid>
        <Grid item mt={5} width="100%">
          <Grid container spacing={3}>
            {cleaningCategories.map((category, index) => (
              <Grid item xs={12} lg={6} key={index}>
                <MKBox mb={1} height="100%">
                  <CircularPhotoCard
                    image={category.image}
                    icon="check"
                    name={category.name}
                    position={category.position}
                    description={category.description}
                  />
                </MKBox>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default EndOfTenancy_Section2;
